import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {Router} from "@angular/router";
import {DataTableDirectives} from "angular2-datatable/datatable";
import {FORM_DIRECTIVES, FORM_PROVIDERS, FormControl, FormGroup, REACTIVE_FORM_DIRECTIVES} from "@angular/forms";
import {AlertComponent, BS_VIEW_PROVIDERS, MODAL_DIRECTIVES, ModalDirective} from "ng2-bootstrap/ng2-bootstrap";
import {PaginatePipe, PaginationControlsCmp, PaginationService} from "ng2-pagination";
import {VehiclesService} from "../service/vehicles.service";
import {BankService} from "../service/bank.service";
import {Vehicle} from "../domain/vehicle";
import {Bank} from "../domain/bank";
import {Page} from "../domain/page";
import {LoginService} from "../service/login.service";
import {User} from "../domain/user";
import {FILE_UPLOAD_DIRECTIVES, FileUploader} from "ng2-file-upload/ng2-file-upload";
import {FILE_MAX_SIZE} from "../validators/validators";

@Component({
    selector: 'vehicles-panel',
    template: require('./vehicles.panel.component.html'),
    styles: [require('./vehicles.panel.component.css')],
    directives: [
        DataTableDirectives,
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        /*DATEPICKER_DIRECTIVES,*/
        MODAL_DIRECTIVES,
        PaginationControlsCmp,
        FILE_UPLOAD_DIRECTIVES
    ],
    providers: [
        FORM_PROVIDERS,
        PaginationService
    ],
    viewProviders: [BS_VIEW_PROVIDERS],
    pipes: [PaginatePipe],
})
export class VehiclesPanelComponent implements OnInit, AfterViewInit {

    private data: Vehicle[];

    private filter: Vehicle;

    private banks: Bank[];

    public error: any;
    public reportMessage: string;

    private currentPage: Page;

    public form: FormGroup;

    public itemsPerPage: number;
    public loading: boolean;
    public page: number;
    public total: number;

    public vehicleSelected: Vehicle;
    public bankTodos: Bank;

    private userLogged: User;

    public canEditVehicle: boolean;
    public canDeleteVehicle: boolean;
    public canViewVehicle: boolean;
    public canEditContract: boolean;
    public canDeleteContract: boolean;
    public canViewContract: boolean;

    public showFilters: boolean;

    public oneClickBulkLoad: boolean;

    @ViewChild('bulkLoadVehicle') bulkLoad: ElementRef;
    @ViewChild('bulkLoadVehicleModal') bulkLoadModal: ModalDirective;
    errorsBulkLoad: string[];

    public uploaderBulkLoad: FileUploader;
    public hasBulkLoadDropZoneOver: boolean;

    constructor(private router: Router,
                private vehiclesService: VehiclesService,
                private bankService: BankService,
                private loginService: LoginService) {
        this.init();

        bankService.getBanks().subscribe(
            this.setBanks.bind(this),
            () => {
                this.bindError('Ocurrió un error al cargar los bancos.');
            });

        /*Descomentar si se quiere filtrar en cuanto el formulario cambie*/
        /*this.form.valueChanges
         .debounceTime(400)
         .subscribe(this.find.bind(this));*/
    }

    private init(): void {
        this.data = [];

        this.banks = [];

        this.itemsPerPage = 10;
        this.loading = false;
        this.page = 1;
        this.total = 0;

        this.bankTodos = new Bank();
        this.bankTodos.id = '';
        this.bankTodos.name = 'TODOS';

        this.canEditVehicle = false;
        this.canDeleteVehicle = false;
        this.canViewVehicle = false;
        this.canEditContract = false;
        this.canDeleteContract = false;
        this.canViewContract = false;

        this.showFilters = false;

        this.errorsBulkLoad = [];

        this.createUploaderBulkLoad();

        this.filter = new Vehicle();
        this.form = new FormGroup({
            patent: new FormControl(),
            bank: new FormControl(),
            contractNumber: new FormControl(),
            cuit: new FormControl(),
            itemsPerPage: new FormControl()
        });

        if (!this.filter.contract.bank.id) {
            this.filter.contract.bank = this.bankTodos;
        }

        this.oneClickBulkLoad = false;
    }

    private setBanks(banks: Bank[]): void {
        this.banks = banks;
        if (banks.length == 1) {
            this.filter.contract.bank = banks[0];
        }
    }

    public find(): void {
        this.getData(1);
    }

    public filterEmpty(): boolean {
        return !(this.filter.patent || this.filter.contract.contractNumber ||
            this.filter.contract.cuit || (this.filter.contract.bank && this.filter.contract.bank.id != ''));
    }

    private getData(page: number): void {
        this.error = null;
        this.reportMessage = null;
        if (!this.filterEmpty()) {
            this.loading = true;
            this.vehiclesService.findVehicles(this.filter, page, this.itemsPerPage).subscribe(
                (data) => {
                    this.refreshData(data);
                    this.page = page;
                },
                () => {
                    this.bindError('Ocurrió un error al buscar los vehículos.');
                });
        }
    }

    private refreshData(page: Page): void {
        this.data = page.content;
        this.currentPage = page;
        this.total = page.totalElements;
        this.loading = false;
    }

    public removeItem(deleteModal: any): void {
        this.error = null;
        this.vehiclesService.delete(this.vehicleSelected.contract.id, this.vehicleSelected.id).subscribe(
            () => {
                deleteModal.hide();
                this.removeItemFromView(this.vehicleSelected);
            },
            () => {
                this.bindError('Ocurrió un error al eliminar el vehículo.');
            });
    }

    private removeItemFromView(vehicle: Vehicle): void {
        let index = this.data.indexOf(vehicle);
        if (index > -1) {
            this.data.splice(index, 1);
        }
        this.vehicleSelected = null;
    }

    public editItem(item: Vehicle): void {
        this.router.navigate(['app/home/editVehicle', item.contract.id, item.id, false]);
    }

    public createVehicle(): void {
        this.router.navigate(['app/home/createVehicle']);
    }

    public downloadFilterVehicles(): void {
        this.error = null;
        if (!this.filterEmpty()) {
            this.loading = true;

            this.reportMessage = 'Creando reporte...';

            /*
             * Se exportan todos los vehículos que cumplan con el filtro.
             * Sólo los vehículos de la página actual se descargan.
             */
            let url = window.location.origin +
                VehiclesService.getURLFilterVehicles(this.filter, this.page, this.itemsPerPage);
            window.location.href = url;

            this.loading = false;

            /*this.vehiclesService.downloadFilterVehicles(this.filter, this.page, this.itemsPerPage).subscribe(
             data => {
             this.loading = false;
             if (data.url == null) {
             if (navigator.appName == 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/) ||
             navigator.userAgent.match(/rv 11/))) {
             /!*alert("Please dont use IE.");*!/
             window.location.href = this.vehiclesService
             .downloadFilterVehiclesForIE(this.filter, this.page, this.itemsPerPage);
             } else {

             this.bindError('Ocurrió un error al descargar los vehículos filtrados.');
             console.error('Response.url is null');
             }
             } else {
             window.location.href = data.url;
             }
             },
             () => {
             this.bindError('Ocurrió un error al descargar los vehículos filtrados.');
             });*/
        }
    }

    public close(saved: Vehicle): void {
        if (saved) {
            this.find();
        }
    }

    public getPage(page: number): void {
        this.getData(page);
    }

    public viewContract(item: Vehicle): void {
        this.router.navigate(['app/home/editContract', item.contract.id]);
    }

    public ngOnInit() {
        this.userLogged = this.loginService.getUserLogged();
        this.canEditVehicle = this.userLogged.isActionAllowed('VEHICLES', 'EDIT', 'VEHICLES');
        this.canDeleteVehicle = this.userLogged.isActionAllowed('VEHICLES', 'DELETE', 'VEHICLES');
        this.canViewVehicle = this.userLogged.isActionAllowed('VEHICLES', 'VIEW', 'VEHICLES');
        this.canEditContract = this.userLogged.isActionAllowed('VEHICLES', 'EDIT', 'CONTRACTS');
        this.canDeleteContract = this.userLogged.isActionAllowed('VEHICLES', 'DELETE', 'CONTRACTS');
        this.canViewContract = this.userLogged.isActionAllowed('VEHICLES', 'VIEW', 'CONTRACTS');

        if (this.userLogged.rol.client) {
            if (this.userLogged.cuit) {
                this.filter.contract.cuit = this.userLogged.username;
            } else {
                this.filter.patent = this.userLogged.username;
            }
            this.filter.contract.bank.id = this.userLogged.bank.id;
            this.showFilters = false;
        } else {
            this.showFilters = true;
        }
    }

    public createUploaderBulkLoad(): void {
        this.uploaderBulkLoad = new FileUploader({
            url: 'vehicle/bulkLoad',
            maxFileSize: FILE_MAX_SIZE,
            /*allowedMimeType: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']*/
        });
        this.hasBulkLoadDropZoneOver = false;

        this.uploaderBulkLoad.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
            this.reportMessage = null;
            if (status == 200) {//OK
                let message = response.split("|");
                this.errorsBulkLoad = [];
                this.errorsBulkLoad[0] = message[0];

                if (message.length > 1) {
                    window.location.href = window.location.origin +
                        VehiclesService.getURLVehicleBulkload(message[1]);
                }
            } else if (status == 400) {//BAD_REQUEST
                if (response == "") {
                    this.errorsBulkLoad = [];
                    this.errorsBulkLoad[0] = "Archivo de carga masiva de vehículos no válido.";
                } else {
                    this.errorsBulkLoad = JSON.parse(response);

                    window.location.href = window.location.origin +
                        VehiclesService.getURLVehicleBulkload(this.errorsBulkLoad[this.errorsBulkLoad.length - 1]);

                    this.errorsBulkLoad.splice(-1, 1);
                    this.errorsBulkLoad.unshift("Carga masiva de vehículos cancelada.");
                }
            }
            this.showBulkLoadModal();
            this.oneClickBulkLoad = false;
        };
    }

    public fileOverBulkLoad(e: any): void {
        this.hasBulkLoadDropZoneOver = e;
    }

    /**
     * Se busca que no exista ningún archivo excel en la cola,
     * previo a ingresar un nuevo excel.
     * */

    /*public checkDuplicatedExcel():boolean {
     let existExcelInQueue = false;
     if (this.uploaderBulkLoad.queue.length > 0) {
     this.uploaderBulkLoad.queue.map((aFile) => {
     let extensionFile = aFile.file.name.substr(aFile.file.name.lastIndexOf('.') + 1).toLowerCase();
     if (extensionFile == 'xls' || extensionFile == 'xlsx') {
     existExcelInQueue = true;
     }
     });
     }
     return existExcelInQueue;
     }*/

    public ngAfterViewInit() {
        /*Limpieza de inputs al agregar a la cola el archivo*/
        this.uploaderBulkLoad.onAfterAddingFile = (
            item => {
                this.bulkLoad.nativeElement.value = '';
                this.reportMessage = null;
            });
    }

    public showBulkLoadModal(): void {
        this.bulkLoadModal.show();
        this.disableLoading();
    }

    public hideBulkLoadModal(): void {
        this.bulkLoadModal.hide();
        this.errorsBulkLoad = [];
    }

    public disableLoading(): void {
        this.loading = false;
        this.oneClickBulkLoad = false;
    }

    public enableLoading(): void {
        this.loading = true;
    }

    public enableOneClickBulkload(): void {
        this.oneClickBulkLoad = true;
    }

    private bindError(messageError: string): void {
        this.loading = false;
        if (this.error == null) {
            this.error = messageError;
        } else {
            this.error = this.error.toString() + ' ' + messageError;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/vehicles/vehicles.panel.component.ts
 **/